import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import merge from 'lodash/merge';
import { ActivatedRoute, Router } from '@angular/router';

import { Lang2 } from 'package-types';

import { ToursSearchEndpoint } from '../api/tours-search.endpoint';
import { transformLinkWithCurrentLang } from '@helpers/language.helper';
import { normalizeParams, normalizeSearchParams } from '@helpers/url-params.helper';
import { QueryParamsService } from '@services/query-params.service';
import { defaultToursSearchSort, ToursSearchSort } from '@interfaces/services/api/tours-search.endpoint';

import { SearchParams } from '@interfaces/modules/tours/search';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  constructor(
    private toursSearch: ToursSearchEndpoint,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private queryParamsService: QueryParamsService
  ) { }

  navigateToSearchPage(params: SearchParams) {
    const page = 1;
    const lang = this.translate.currentLang as Lang2;
    const sort = this.getCurrentSort();

    return this.toursSearch.search(params, lang, page, sort)
      .pipe(
        tap(({ url, searchId }) => this.navigateToFoundPage(url, lang, searchId, params, sort))
      );
  }

  private navigateToFoundPage(url: string, lang: Lang2, searchId: string, search: SearchParams, sort = defaultToursSearchSort): void {
    this.router.navigate([transformLinkWithCurrentLang(url, lang)], {
      relativeTo: this.route,
      queryParams: merge({ searchId }, normalizeSearchParams(search), normalizeParams({ sort })),
    }).then();
  }

  private getCurrentSort(): ToursSearchSort {
    const snapshotSort = this.queryParamsService.getParsedParamsSnapshot().sort;

    return snapshotSort ?? defaultToursSearchSort;
  }
}
